import React from 'react';
import { Accordion, AccordionItemData } from './Accordion';
import { CTAButton } from './CTAButton';
const ficha = 'Ficha de 1 página: qué es en una frase, analogía cotidiana, por qué importa, error común + corrección, diagrama del tema y frase para el pizarrón.';
const quimica: AccordionItemData[] = [{
  title: '⚛️ Modelo atómico',
  body: ficha
}, {
  title: '🧾 Tabla periódica',
  body: ficha
}, {
  title: '🧠 Truco mnemotécnico primeros 20 elementos',
  body: ficha
}, {
  title: '🔗 Uniones químicas',
  body: ficha
}, {
  title: '⚗️ Reacciones y balanceo',
  body: ficha
}, {
  title: '⚖️ Estequiometría',
  body: ficha
}, {
  title: '🧪 Ácidos y bases',
  body: ficha
}, {
  title: '💧 Soluciones y concentración',
  body: ficha
}];
const fisica: AccordionItemData[] = [{
  title: '🏃 Cinemática (MRU y MRUV)',
  body: ficha
}, {
  title: '🍎 Fuerzas y leyes de Newton',
  body: ficha
}, {
  title: '🔋 Energía y trabajo',
  body: ficha
}, {
  title: '🎈 Presión',
  body: ficha
}, {
  title: '🌡️ Calor y temperatura',
  body: ficha
}, {
  title: '🔊 Ondas (sonido y luz)',
  body: ficha
}, {
  title: '💡 Electricidad (circuitos y Ley de Ohm)',
  body: ficha
}, {
  title: '🧲 Magnetismo',
  body: ficha
}];
export function Temas() {
  return <section className="px-4 py-10" aria-labelledby="temas-title" data-id="element-174" data-mp="21y48s9hz72i4">
      <h2 id="temas-title" className="text-center font-display text-xl font-extrabold text-white" data-id="element-175" data-mp="26wfj0lc6nf0v">
        Para eso preparamos estas herramientas
      </h2>
      <p className="mt-2 text-center text-sm text-teal-100/70" data-id="element-176" data-mp="2bp8o5abkcpdh">
        16 temas clave, resueltos y listos para dar clase.
      </p>

      <h3 className="mt-7 font-display text-sm font-bold uppercase tracking-wider text-orange-300" data-id="element-177" data-mp="2koc96juajeum">
        Química (8 temas)
      </h3>
      <div className="mt-3" data-id="element-178" data-mp="2pnf43bgk44ov">
        <Accordion items={quimica} numbered startIndex={1} data-id="element-179" data-mp="2pkkk1l1gglvz" />
      </div>

      <h3 className="mt-7 font-display text-sm font-bold uppercase tracking-wider text-orange-300" data-id="element-180" data-mp="pl759dyzgtxs">
        Física (8 temas)
      </h3>
      <div className="mt-3" data-id="element-181" data-mp="zah1n60v0yrp">
        <Accordion items={fisica} numbered startIndex={9} data-id="element-182" data-mp="zaqqgqa64zvt" />
      </div>

      <p className="mt-6 rounded-xl border border-teal-300/20 bg-[#0f4c4c]/60 p-4 text-center text-[13px] leading-relaxed text-teal-50" data-id="element-183" data-mp="ujqsdhpbcbrq">
        <strong className="text-white" data-id="element-184" data-mp="18a44zxd5gene">Cada ficha trae:</strong> qué es en una
        frase, analogía cotidiana, por qué importa, error común + corrección,
        diagrama del tema y frase para el pizarrón.
      </p>

      <div className="mt-6" data-id="element-185" data-mp="1i8tcqxbc0ipx">
        <CTAButton data-id="element-186" data-mp="1i6z006a7rwwx" />
      </div>
    </section>;
}